import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ChevronLeftSmall = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M11.2618138,14.7530611 C10.0178163,13.517245 9,12.5033559 9,12.4999747 C9,12.4878975 13.5239265,8 13.5361002,8 C13.5429331,8 13.7712589,8.22132081 14.0434919,8.49182412 L14.5384615,8.98364813 L12.7624706,10.7479715 L10.9864796,12.5122949 L12.7561278,14.2703168 L14.525775,16.0283394 L14.0373017,16.5141692 C13.768641,16.7813757 13.5431578,17 13.5362279,17 C13.529298,17 12.5058112,15.9888771 11.2618138,14.7530611 Z"
        />
    </StarryUIIcon>
);
